export default __webpack_public_path__ + "static/media/icon_instagram.c960fcf1.webp";